import type { CONTENT_TYPE } from '~~/lib/ContentfulService';
import componentMap from '~/components/global/mapping';

type EntryWithContentType = {
  sys?: {
    contentType?: {
      sys?: {
        id?: string;
      };
    };
  };
};

/**
 * Maps a Ninetailed baseline/variant entry to its Contentful Vue component.
 * Cross-content-type variants must not keep the baseline component.
 */
export const resolveMappedComponentForEntry = <T>(
  entry: EntryWithContentType | undefined,
  fallbackComponent: T
): T | (typeof componentMap)[CONTENT_TYPE] => {
  const contentTypeId = entry?.sys?.contentType?.sys?.id as
    CONTENT_TYPE | undefined;

  if (contentTypeId && componentMap[contentTypeId]) {
    return componentMap[contentTypeId];
  }

  return fallbackComponent;
};
